import {spac} from 'constants/url';
import useDelete from '../../../components/hooks/useDelete';
import {DeletingOptions} from '../../../components/grid-dx/types';

function useDeleteSpac() {
  const deleteSpac = useDelete(spac);
  return (deletingOptions: DeletingOptions) => deleteSpac(deletingOptions);
}

export default useDeleteSpac;
